import { render, staticRenderFns } from "./fakeInput.vue?vue&type=template&id=0918547a&"
import script from "./fakeInput.vue?vue&type=script&lang=js&"
export * from "./fakeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports